const CHARACTER_LIMIT = 88;

const initFeaturedContent = () => {
  const featureContentSubtitles = document.querySelectorAll(
    ".js-feature-content-subtitle",
  );

  console.log("featured subtitle: ", featureContentSubtitles);

  featureContentSubtitles.forEach((subtitle) => {
    let newSummary = "";
    const summary = subtitle.innerHTML;
    if (summary && summary.length > CHARACTER_LIMIT) {
      newSummary = summary.substring(0, CHARACTER_LIMIT);
      newSummary += "...";
      subtitle.innerHTML = newSummary;
    }
  });
};

export default initFeaturedContent;
